/**
 * List of page slugs that should use partner page configuration
 * for header and footer overrides
 */
export const PARTNER_PAGE_SLUGS = [
  '4front',
  'aaacu',
  'affinity',
  'align',
  'alliance',
  'amfirst',
  'amplify',
  'apcuparc',
  'auburn',
  'bath',
  'bbtames',
  'boaa',
  'boh',
  'bossier',
  'bmark',
  'brentwood',
  'bulldog',
  'cap',
  'cartercu',
  'cbna',
  'cbi',
  'central',
  'cfcu',
  'citycountycu',
  'cornerstone',
  'country',
  'CPB',
  'cu1a',
  'cunj',
  'cyfair',
  'dcu',
  'dfcu',
  'dirigo',
  'ecu',
  'essex',
  'everence',
  'extra',
  'facu',
  'famsav',
  'fcbbanks',
  'firsteagle',
  'firstmidwest',
  'fmbank',
  'fmfcu',
  'fnbames',
  'fnbbank',
  'fnbhutch',
  'fnbky',
  'fnbla',
  'forte',
  'fpcfcu',
  'frfcu',
  'gcircle',
  'gfa',
  'gplains',
  'greenstate',
  'greenwich',
  'gsb',
  'guardiancu',
  'harco',
  'hcb',
  'heart',
  'hefcu',
  'hw',
  'iaa',
  'inb',
  'indfed',
  'issbames',
  'jefferson',
  'jvb',
  'ldb',
  'liberty',
  'maps',
  'members',
  'mercantile',
  'metroma',
  'mfcu',
  'mmccu',
  'montecito',
  'mountainone',
  'msgcu',
  'nesb',
  'nsbank',
  'nsbnc',
  'nt',
  'nwpcu',
  'ohiovalley',
  'omb',
  'P1FCU',
  'pacprem',
  'panhandle',
  'parkbank',
  'patrons',
  'philafcu',
  'pioneerfcu',
  'plb',
  'powerfcu',
  'psecu',
  'quincy',
  'readingcb',
  'rrcu',
  'rsbames',
  'sacobid',
  'sbcu',
  'sbod',
  'sbtames',
  'secu',
  'skyline',
  'skyone',
  'spccu',
  'statebank',
  'strata',
  'sturgis',
  'teamone',
  'telcomm',
  'telhio',
  'texastrust',
  'TheAtlanticFCU',
  'torrington',
  'tricity',
  'tru',
  'trumark',
  'truno',
  'tvacu',
  'tvb',
  'ubnc',
  'ubtames',
  'ucb',
  'ucbla',
  'usfcu',
  'usouthernb',
  'velocitycu',
  'vfcu',
  'wafd',
  'wafd-employee',
  'westaircomm',
  'westerly',
  'wildfire',
  'wilsonbank',
  'wsfs',
  'y12',
  'yolofcu'
] as const;

export const isPartnerPageSlug = (slug: string): boolean => {
  return PARTNER_PAGE_SLUGS.includes(slug as any);
};
